import NonTechnicalSummary from "@/components/ssp/missions/mission/mission-global-synthesis/NonTechnicalSummary.vue";
import Incertitudes from "@/components/ssp/missions/mission/mission-global-synthesis/Incertitudes.vue";
const ConclusionAndRecommandations = () =>
  import(
    /* webpackChunkName: "ConclusionAndRecommandations" */ "@/components/ssp/missions/mission/mission-global-synthesis/ConclusionAndRecommandations.vue"
  );

export default [
  {
    path: "",
    name: "ConclusionAndRecommandations",
    component: ConclusionAndRecommandations,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "non-technical-summary",
    name: "NonTechnicalSummary",
    component: NonTechnicalSummary,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "incertitudes",
    name: "Incertitudes",
    component: Incertitudes,
    meta: {
      showSubNavBar: true,
    },
  },
];
